module.exports = __webpack_public_path__ + "img/share.d58d27e9.svg";